import { forwardRef } from 'react';

import './input.scss';

export const Input = forwardRef(
  (
    {
      label,
      type,
      name,
      value,
      placeholder,
      onChange,
      onFocus,
      required,
      filled = true,
      bordered,
      style,
      icon: Icon,
      clearIcon: ClearIcon,
      error,
      display = false,
      props = {},
      disabled
    },
    ref
  ) => {
    const handleOnChange = (event) => {
      if (type === 'file') {
        return onChange(event);
      }
      const { name, value } = event.target;
      onChange({ name, value });
    };

    return (
      <div
        className={`form-input ${filled ? 'form-input--filled' : ''} ${bordered ? 'form-input--bordered' : ''}
      ${error ? 'form-input--error' : ''}`}
        style={style}
      >
        {label && (
          <label htmlFor={name}>
            {label}
            {required && !display ? <span> *</span> : ''}
          </label>
        )}
        <div>
          {Icon && <Icon className="form-input__icon" width={20} height={20} />}
          {display && type === 'date' ? (
            <span>
              {value
                ? new Date(value).toLocaleDateString('en-ZA', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                  })
                : ''}
            </span>
          ) : (
            <input
              ref={ref}
              type={type}
              id={name}
              name={name}
              value={value}
              {...props}
              disabled={disabled}
              placeholder={placeholder}
              readOnly={display}
              onChange={handleOnChange}
              onFocus={onFocus}
              style={Icon ? { paddingLeft: 40 } : {}}
            />
          )}
          {ClearIcon && value && (
            <ClearIcon
              className="form-input__clear-icon"
              width={20}
              height={20}
              onClick={() => onChange({ name, value: '' })}
            />
          )}
        </div>
      </div>
    );
  }
);
